function readRequired(key: string): string {
  const raw = (import.meta.env as Record<string, string | undefined>)[key];
  const value = typeof raw === 'string' ? raw.trim() : '';
  if (value === '') {
    if (import.meta.env.DEV) {
      console.warn(
        `[env] ${key} is not set. Falling back to dev default. Configure apps/admin/.env.local`,
      );
      return key === 'VITE_API_URL' ? 'http://localhost:3000' : '';
    }
    throw new Error(`Missing required env var: ${key}`);
  }
  return value;
}

const API_URL = readRequired('VITE_API_URL').replace(/\/$/, '');
const API_VERSION = (import.meta.env.VITE_API_VERSION as string | undefined)?.trim() || '1';

export function apiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}/${API_VERSION}${normalized}`;
}

/** Raw API origin (no version prefix). Use sparingly — for non-versioned
 * endpoints or for constructing CSV/download URLs that mirror the standard
 * versioned base. */
export function apiOrigin(): string {
  return `${API_URL}/${API_VERSION}`;
}

export const SENTRY_DSN = (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '';
export const APP_ENV = import.meta.env.MODE;
